import { Link, useRouter } from 'expo-router';
import * as Updates from 'expo-updates';
import { Platform } from 'react-native';
import Box from '@/components/UI/Box';
import Button from '@/components/UI/Button';
import Item from '@/components/UI/PressableRow';
import Row from '@/components/UI/Row';
import Text from '@/components/UI/Text';
import Icon from '@/components/Unistyles/Icon';
import useGenerateDm from '@/hooks/useGenerateDm';
import useSignOut from '@/hooks/useSignOut';
import useSupportPersonId from '@/hooks/useSupportPersonId';
import useUserId from '@/hooks/useUserId';
import useRootStore, { closeDrawer } from '@/stores/useRootStore';

export default function ProfileMenu() {
  const signOut = useSignOut();
  const supportUserId = useSupportPersonId();
  const userId = useUserId();
  const { isUpdatePending } = Updates.useUpdates();
  const generateDm = useGenerateDm();
  const { dismissTo } = useRouter();
  const onPressSupport = async () => {
    if (!supportUserId) return;
    const id = await generateDm(supportUserId);
    if (id) {
      closeDrawer();
      dismissTo(
        {
          pathname: '/chat/[chatId]',
          params: {
            chatId: id,
          },
        },
        { withAnchor: true },
      );
    }
  };
  const onPressReload = () => {
    useRootStore.setState({
      dismissedUpdateId: null,
    });
    Updates.reloadAsync();
  };
  return (
    <>
      {isUpdatePending ? (
        <Row spaced>
          <Text variant="primary">New update is available.</Text>
          <Button onPress={onPressReload} size="xs">
            <Button.Text>Update</Button.Text>
          </Button>
        </Row>
      ) : null}
      {Platform.OS !== 'web' ? (
        <Link href="/profile/notification" asChild>
          <Item>
            <Icon name="notifications-outline" />
            <Text>Notifications</Text>
          </Item>
        </Link>
      ) : null}
      <Link href="/profile/appearance" asChild>
        <Item>
          <Icon name="moon-outline" />
          <Text>Appearance</Text>
        </Item>
      </Link>
      {supportUserId && supportUserId !== userId ? (
        <Item onPress={onPressSupport}>
          <Icon name="chatbubble-outline" />
          <Box direction="vertical">
            <Text>Chat With Support</Text>
            <Text variant="typographySecondary" size="xs">
              Have any feedback or questions?
            </Text>
            <Text variant="typographySecondary" size="xs">
              Chat with us now, directly from the app.
            </Text>
          </Box>
        </Item>
      ) : null}
      {supportUserId !== userId ? (
        <Link href="/profile/account" asChild>
          <Item>
            <Icon name="person-outline" />
            <Text>Account</Text>
          </Item>
        </Link>
      ) : null}

      {Platform.OS !== 'web' ? (
        <Link href="/profile/about" asChild>
          <Item>
            <Icon name="information-circle-outline" />
            <Text>About</Text>
          </Item>
        </Link>
      ) : null}
      <Item onPress={signOut}>
        <Icon name="log-out-outline" />
        <Text>Sign Out</Text>
      </Item>
    </>
  );
}
